import { render, staticRenderFns } from "./SolanRubricsTableHeaderRow.vue?vue&type=template&id=75cf58f0&scoped=true&"
import script from "./SolanRubricsTableHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./SolanRubricsTableHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanRubricsTableHeaderRow.vue?vue&type=style&index=0&id=75cf58f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cf58f0",
  null
  
)

export default component.exports